import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3
              className="text-xl font-heading text-background-50 mb-4"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              韩漫网
            </h3>
            <p className="text-sm text-background-300 leading-relaxed">
              专业提供海量漫画免费韩漫，支持下拉式韩漫在线阅读，涵盖丰富的阅读漫画大全资源，让你随时随地畅享高清流畅的阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/love" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                  漫画分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/love" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                  恋爱漫画
                </Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                  奇幻漫画
                </Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                  动作漫画
                </Link>
              </li>
              <li>
                <Link to="/category/mystery" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                  悬疑漫画
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-mail-line"></i>
                <span>contact@hanman-site.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-customer-service-2-line"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; 2026 韩漫网 - 漫画免费韩漫 | 下拉式韩漫在线 | 阅读漫画大全 | 韩漫网站. 版权所有.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}